export const speakerSrc = (photo, w) => {
  if (!photo) return undefined;
  const base = photo.replace(/^\/img\//, "").replace(/\.\w+$/, "");
  return `/img/speakers/${base}-${w}.webp`;
};

export const speakerSrcSet = (photo) =>
  photo ? `${speakerSrc(photo, 640)} 640w, ${speakerSrc(photo, 960)} 960w` : undefined;

export const speakerInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
